import React from 'react'
import styled from 'styled-components'
import SVGInline from '@/v2/components/common/SVGInline'
import Typography from '@/v2/components/common/Typography'
import { formatPhone } from '@/v2/utils/format'
import Button from '@/v2/components/common/Button'
import PatientAvatar from '@/v2/components/common/PatientAvatar'
import PersonIcon from '#/assets/images/icons/v2/profile.svg?raw'
import MessageIcon from '#/assets/images/icons/v2/write-messages.svg?raw'
import Labels from '@/v2/modals/appointment/AppointmentDetails/Labels'
import { Skeleton } from '@mui/material'

const PatientWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 16px;
`

const PatientProfileHeader = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
`

const PatientProfile = styled.div`
  display: flex;
  flex-direction: column;
`

const PatientActions = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
`

const MobilePatient = ({ patient, appointment }) => {
  if (!patient) return <Skeleton variant="rectangular" height={200} />

  return (
    <PatientWrapper>
      <PatientProfileHeader>
        <PatientAvatar patient={patient} size={60} />
        <PatientProfile>
          <Typography
            fontSize="18px"
            fontWeight="600"
            marginBottom="4px"
            variant="h3"
          >
            {patient.fullName}
          </Typography>
          <Typography variant="h5" fontSize="14px" color="textSecondary">
            {patient.email}
          </Typography>
          <Typography variant="h5" fontSize="14px" color="textSecondary">
            {formatPhone(patient.phoneNumber)}
          </Typography>
        </PatientProfile>
      </PatientProfileHeader>

      <PatientActions>
        <Button
          variant="profile"
          startIcon={
            <SVGInline
              className="message-icon"
              svg={PersonIcon}
              height="12px"
              width="12px"
            />
          }
          href={`/v2/patient/${patient.id}/profile`}
        >
          See Profile
        </Button>

        <Button
          variant="profile"
          startIcon={<SVGInline svg={MessageIcon} height="12px" width="12px" />}
          href={`/v2/messages/start-conversation/${patient.id}`}
          onClick={e => {
            if (patient.phoneNumber === null) {
              e.preventDefault()
              e.stopPropagation()
              alert(
                "This patient doesn't have a phone number!\nPlease, update the patient contact info."
              )
            }
          }}
        >
          Send Message
        </Button>
      </PatientActions>

      <Labels appointment={appointment} />
    </PatientWrapper>
  )
}

export default MobilePatient
